import { styled } from "styled-components";

const ResponseLoading = () => {
  return (
    <StyledContainer>
      <img
        alt="avatar"
        src={"images/smart-search/chat/OG.gif"}
        className="avatar"
      />
      <p>Generating answers for you…</p>
    </StyledContainer>
  );
};

export default ResponseLoading;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  img {
    width: 30px;
    height: 30px;
  }
  p {
    color: #040726;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.285px;
    margin-left: 10px;
    font-size: 13px;
  }
`;
